"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconVideoGamePacman = /*#__PURE__*/
function (_Icon) {
  _inherits(IconVideoGamePacman, _Icon);
  function IconVideoGamePacman(props) {
    var _this;
    _classCallCheck(this, IconVideoGamePacman);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconVideoGamePacman).call(this, props));
    _this.name = 'IconVideoGamePacman';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "video-game-pacman_svg__group0"
    }, _react2.default.createElement("path", {
      className: "video-game-pacman_svg__path0",
      d: "M13.164 24a11.924 11.924 0 01-8.467-3.565c-2.253-2.28-3.483-5.301-3.464-8.506s1.285-6.211 3.565-8.465A11.95 11.95 0 0113.252 0h.051a11.91 11.91 0 019.332 4.642l.025.034a.997.997 0 01-.25 1.397L14.027 12l8.418 5.952c.218.166.355.401.392.665a.99.99 0 01-.195.74A12.056 12.056 0 0113.175 24h-.011zm.065-23A10.933 10.933 0 005.5 4.176a10.93 10.93 0 00-3.268 7.759c-.017 2.933 1.112 5.701 3.18 7.793s4.822 3.254 7.755 3.271c3.376 0 6.618-1.59 8.68-4.252l-8.395-5.932a.99.99 0 01-.409-.645.996.996 0 01.403-.986l8.391-5.932A10.898 10.898 0 0013.295 1h-.066z"
    }), _react2.default.createElement("path", {
      className: "video-game-pacman_svg__path1",
      d: "M10.66 9c-1.379 0-2.5-1.121-2.5-2.5S9.282 4 10.66 4s2.5 1.121 2.5 2.5S12.039 9 10.66 9zm0-4c-.827 0-1.5.673-1.5 1.5S9.833 8 10.66 8s1.5-.673 1.5-1.5-.672-1.5-1.5-1.5z"
    })));
    return _this;
  }
  return IconVideoGamePacman;
}(_Icon3.default);
exports.default = IconVideoGamePacman;